import Vue from './common/vue-common';
import cr$ from "../common/crquery";
import FooterNewsletter from "./components/footer/FooterNewsletter";
import LazyLoad from "vanilla-lazyload";
import FooterContact from "./components/footer/FooterContact";
import {getScope} from "../common/common";

cr$.ready(() => {
    if (cr$.byId('footer-newsletter-vue').exists()) {
        let lazy = new LazyLoad({
            elements_selector: '#footer-newsletter-vue',
            callback_enter: () => {
                new Vue(FooterNewsletter);
                setTimeout(() => lazy.destroy(), 500);
            }
        });
    }

    if (getScope('IS_WHOLESALER') && cr$.byId('footer-contact-vue').exists()) {
        let lazy = new LazyLoad({
            elements_selector: '#footer-contact-vue',
            callback_enter: () => {
                new Vue(FooterContact);
                setTimeout(() => lazy.destroy(), 500);
            }
        });
    }
});